import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sm/wds-react';
import { t, defineMessages } from '@sm/intl';
import { createUseStyles } from 'react-jss';
import { useSurveyTheme, createSurveyStyles } from '@sm/webassets';
import { generateMetricsAttribute } from '@sm/metrics';

const DEFAULT_COPY = defineMessages({
  DONE: {
    id: 'ActionGroup.Done',
    defaultMessage: 'Done',
    description: '[Type: Button][Vis.: low] - Done button',
  },
});

const useThemeStyles = createUseStyles(theme => ({
  actionGroupContainer: {
    margin: [theme?.spacing[4], 80],
    fontSize: theme?.type.cardTitle,
    overflowWrap: 'break-word',
  },
  actionGroupCTA: {
    padding: [0, theme?.spacing[5], theme?.spacing[4]],
    textAlign: 'center',
  },
}));

const useStyles = createSurveyStyles(theme => {
  return {
    actionGroupColor: {
      color: theme?.secondaryAccentColor,
      borderColor: theme?.primaryAccentColor,
      backgroundColor: theme?.primaryAccentColor,
    },
    actionGroupButton: {
      extend: 'actionGroupColor',
      fontFamily: theme?.questionBody?.fontFamily,
      transition: 'all 0.2s linear',
      '&:hover': {
        extend: 'actionGroupColor',
        boxShadow: `0 0 4px ${theme?.primaryAccentColor}`,
        outlineOffset: '5px',
        outline: `1px solid ${theme?.primaryAccentColor}`,
      },
    },
  };
});

const ActionGroup = ({ qrDoneUrl }) => {
  const theme = useSurveyTheme();
  const { actionGroupContainer, actionGroupCTA } = useThemeStyles();
  const { actionGroupButton } = useStyles();
  const acBtnColor = theme.isDark ? 'black' : 'primary';

  return (
    <div className={actionGroupContainer}>
      <div className={actionGroupCTA}>
        <Button
          data-testid="ActionGroup__QuizDone"
          className={actionGroupButton}
          size="lg"
          color={acBtnColor}
          href={qrDoneUrl}
          data-sm-metrics={generateMetricsAttribute({
            data: {
              actionFlow: 'smwebQuizResultsDoneBtn',
              actionType: 'quiz_results_done',
              button: 'quiz_results_done',
              uiTrigger: 'quiz_results_done_btn',
              log: {
                level: 'info',
                message: 'smweb quiz results done button clicked',
              },
            },
          })}
        >
          {t(DEFAULT_COPY.DONE)}
        </Button>
      </div>
    </div>
  );
};

ActionGroup.propTypes = {
  qrDoneUrl: PropTypes.string,
};

ActionGroup.defaultProps = {
  qrDoneUrl: '/',
};

export default ActionGroup;
